<style scoped>

  .action-icon:hover {
    color: #2987CD;    
  }

  .content {
    min-height: 200px;
  }

</style>

<template>

  <div class="ui card">

    <loader :visible="loading" />

    <div class="content">      
      <i class="right floated camera icon clickable action-icon" @click="onShowPictures()"></i>
      <i class="right floated edit icon m-r-5 clickable action-icon" @click="onUpdate()"></i>
      <div class="header">
        {{ animalData.name }}
        <i v-if="animal.dead" class="cross grey icon m-l-5"></i>  
      </div>
      <div class="meta">
        {{ animal.race.name }}
        <span class="ui tiny label m-l-10">Espécie {{ animalData.race.species.name }}</span> 
      </div>  
      <div v-if="pictures.length > 0 && !loading" class="ui tiny rounded centered images m-t-20">
        <img v-for="picture in pictures" class="ui middle aligned clickable image" :src="picture.url"
          @click="onShowPictures()">                    
      </div>    
      <div v-if="pictures.length == 0 && !loading" class="center aligned description m-t-50">
        <button class="ui small basic blue button" @click="onShowPictures()">
          Adicionar fotos
        </button>
      </div>
    </div>    

    <div class="extra content">
      <span v-if="animalData.sex == 'male'" class="left floated">
        <i class="mars blue icon"></i>Macho
      </span>
      <span v-if="animalData.sex == 'female'" class="left floated">
        <i class="venus pink icon"></i>Fêmea
      </span>
      <span v-if="animalData.sex == 'undefined'" class="left floated">
        <i class="question circle grey icon"></i>Indefinido
      </span>
      <span v-if="animalData.age" class="right floated">
        <i class="calendar outline icon"></i> {{ animalData.age }}
      </span>
    </div>    

    <animal-form-modal ref="animalFormModal" @onSave="$emit('onUpdate')" @onRemove="$emit('onUpdate')" 
      @onShowPictures="onShowPictures()" @onShowOwner="onShowOwner" />
    
    <animal-pictures-modal ref="animalPicturesModal" @onUploadOrRemove="loadPictures()" />
    
    <owner-modal ref="ownerModal" @onSave="$emit('onUpdateOwner')" @onShowAnimals="onShowAnimals" />

  </div>    

</template>

<script>

  import moment from "@/utils/moment"
  import Loader from "@/components/loader"
  import AnimalService from "@/services/animal-service"
  import AnimalFormModal from "./form-modal"
  import AnimalPicturesModal from "./pictures-modal"  
  import OwnerModal from "@/pages/entries/owners/form-modal"

  export default {

    name: "AnimalCard",

    data() {
      return {
        loading: true,
        animalData: {},
        pictures: [],
        service: new AnimalService(),
      }
    },
    
    props: ["animal"],

    components: {
      Loader,
      AnimalFormModal,
      AnimalPicturesModal,
      OwnerModal,
    },

    created() {

      this.animalData = this.$cloneObject(this.animal)
      
      if (this.animalData.birthDate)
        this.animalData.age = moment.formatAge(this.animalData.birthDate)
      
      this.loadPictures()
    },

    methods: {

      onShowPictures() {
        this.$refs.animalPicturesModal.show(this.animalData.id)
      },

      onShowOwner(owner) {
        this.$refs.ownerModal.update(owner)
      },

      onShowAnimals(owner) {
        this.$router.push(`/entries/owners/${owner.id}/animals`)
      },

      onUpdate() {
        this.$refs.animalFormModal.update({ animalId: this.animalData.id })
      },

      async loadPictures() {

        this.loading = true

        try {

          this.pictures = await this.service.getAnimalPictures(this.animal.id)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        } 
      },
    },
  }

</script>